/* Ace Apparel theme — vanilla JS, no dependencies. */
(() => {
  const routes = (window.theme && window.theme.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  const strings = (window.theme && window.theme.strings) || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  const lock = (on) => document.body.classList.toggle('is-locked', on);

  /* ------------------------------------------------------------------
     Scroll state — header goes solid once you leave the hero.
     ------------------------------------------------------------------ */
  const announcement = $('.announcement-bar');
  const onScroll = () => {
    const threshold = announcement ? announcement.offsetHeight : 0;
    document.body.classList.toggle('is-scrolled', window.scrollY > threshold);
    const header = $('site-header');
    if (header && header.dataset.transparent === 'true') {
      header.classList.toggle('is-solid', window.scrollY > threshold + 40 || header.classList.contains('is-open'));
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ------------------------------------------------------------------
     Header: mega menu, mobile menu, search
     ------------------------------------------------------------------ */
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.megaTriggers = $$('[data-mega-trigger]', this);
      this.closeTimer = null;

      this.megaTriggers.forEach((btn) => {
        const id = btn.dataset.megaTrigger;
        btn.addEventListener('click', () => {
          const open = btn.getAttribute('aria-expanded') === 'true';
          open ? this.closeAll() : this.openMega(id);
        });
        btn.parentElement.addEventListener('mouseenter', () => {
          if (!isDesktop() || !window.matchMedia('(hover: hover)').matches) return;
          clearTimeout(this.closeTimer);
          this.openMega(id);
        });
      });

      $$('[data-mega-menu]', this).forEach((menu) => {
        // Swap the campaign image as you hover each featured collection.
        $$('[data-mega-image]', menu).forEach((el) => {
          const show = () =>
            $$('[data-mega-figure]', menu).forEach((fig) => fig.classList.toggle('is-active', fig.dataset.megaFigure === el.dataset.megaImage));
          el.addEventListener('mouseenter', show);
          el.addEventListener('focus', show);
        });
        menu.addEventListener('mouseenter', () => clearTimeout(this.closeTimer));
        menu.querySelector('.mega-menu__panel').addEventListener('mouseleave', () => this.scheduleClose());
        // Clicking the dimmed half closes the menu.
        menu.addEventListener('click', (e) => {
          if (!e.target.closest('.mega-menu__panel')) this.closeAll();
        });
      });
      $('.header-menu', this)?.addEventListener('mouseleave', (e) => {
        if (!e.relatedTarget || !e.relatedTarget.closest('[data-mega-menu]')) this.scheduleClose();
      });

      // Mobile menu
      const mobileToggle = $('[data-mobile-menu-toggle]', this);
      const mobileMenu = $('[data-mobile-menu]', this);
      mobileToggle?.addEventListener('click', () => {
        const open = mobileToggle.getAttribute('aria-expanded') === 'true';
        this.closeAll();
        if (!open) {
          mobileMenu.hidden = false;
          mobileToggle.setAttribute('aria-expanded', 'true');
          this.showLevel('root');
          this.setOpen(true);
          lock(true);
        }
      });
      $$('[data-mobile-open]', this).forEach((b) => b.addEventListener('click', () => this.showLevel(b.dataset.mobileOpen)));
      $$('[data-mobile-back]', this).forEach((b) => b.addEventListener('click', () => this.showLevel(b.dataset.mobileBack)));

      // Search
      $$('[data-search-toggle]', this).forEach((btn) =>
        btn.addEventListener('click', () => {
          const panel = $('[data-search-panel]', this);
          const willOpen = panel.hidden;
          this.closeAll();
          if (willOpen) {
            panel.hidden = false;
            this.setOpen(true);
            $('input[type="search"]', panel).focus();
          }
        })
      );
      this.initPredictiveSearch();

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeAll();
      });
      window.addEventListener('resize', () => {
        if (isDesktop() && !$('[data-mobile-menu]', this).hidden) this.closeAll();
      });
    }

    setOpen(open) {
      this.classList.toggle('is-open', open);
      onScroll();
    }

    openMega(id) {
      $$('[data-mega-menu]', this).forEach((m) => {
        const match = m.dataset.megaMenu === id;
        m.hidden = !match;
        m.classList.toggle('is-open', match);
      });
      this.megaTriggers.forEach((b) => b.setAttribute('aria-expanded', String(b.dataset.megaTrigger === id)));
      $('[data-search-panel]', this).hidden = true;
      this.setOpen(true);
    }

    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.closeAll(), 200);
    }

    showLevel(level) {
      $$('.mobile-menu__level', this).forEach((l) => (l.hidden = l.dataset.level !== level));
    }

    closeAll() {
      $$('[data-mega-menu]', this).forEach((m) => {
        m.hidden = true;
        m.classList.remove('is-open');
      });
      this.megaTriggers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      const mobileMenu = $('[data-mobile-menu]', this);
      if (mobileMenu && !mobileMenu.hidden) {
        mobileMenu.hidden = true;
        lock(false);
      }
      $('[data-mobile-menu-toggle]', this)?.setAttribute('aria-expanded', 'false');
      $('[data-search-panel]', this).hidden = true;
      this.setOpen(false);
    }

    initPredictiveSearch() {
      const input = $('[data-predictive-input]', this);
      const results = $('[data-predictive-results]', this);
      if (!input || !results) return;
      let timer;
      let controller;
      input.addEventListener('input', () => {
        clearTimeout(timer);
        const q = input.value.trim();
        if (!q) {
          results.innerHTML = '';
          return;
        }
        timer = setTimeout(async () => {
          controller?.abort();
          controller = new AbortController();
          try {
            const url = `${routes.root.replace(/\/$/, '')}/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
            const res = await fetch(url, { signal: controller.signal });
            const data = await res.json();
            const products = (data.resources && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = `<p class="eyebrow">No results for “${escapeHtml(q)}”</p>`;
              return;
            }
            results.innerHTML = `
              <div class="predictive">
                <ul class="predictive__products" role="list">
                  ${products
                    .map(
                      (p) => `
                    <li><article class="product-card">
                      <a href="${p.url}" class="product-card__media">${
                        p.image ? `<img class="product-card__img" src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''
                      }</a>
                      <div class="product-card__info">
                        <h3 class="product-card__title"><a href="${p.url}">${escapeHtml(p.title)}</a></h3>
                        <div class="product-card__meta"><span class="price">${formatPrice(p.price)}</span></div>
                      </div>
                    </article></li>`
                    )
                    .join('')}
                </ul>
                <a class="link-underline predictive__all" href="${routes.search}?q=${encodeURIComponent(q)}&options[prefix]=last">View all results</a>
              </div>`;
          } catch (err) {
            if (err.name !== 'AbortError') results.innerHTML = '';
          }
        }, 250);
      });
    }
  }
  customElements.define('site-header', SiteHeader);

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  // The suggest API returns prices as decimal strings in the active currency.
  function formatPrice(amount) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(amount));
    } catch (e) {
      return amount;
    }
  }

  /* ------------------------------------------------------------------
     Announcement rotator
     ------------------------------------------------------------------ */
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      const items = $$('.announcement-bar__item', this);
      if (items.length < 2) return;
      let i = 0;
      const ms = (parseInt(this.dataset.interval, 10) || 4) * 1000;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, ms);
    }
  }
  customElements.define('announcement-rotator', AnnouncementRotator);

  /* ------------------------------------------------------------------
     Drawers
     ------------------------------------------------------------------ */
  let lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lock(true);
    const focusable = el.querySelector('[role="dialog"]');
    focusable && setTimeout(() => focusable.focus({ preventScroll: true }), 50);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    lock(false);
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }

  class SideDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target === this || e.target.closest('[data-drawer-close]')) closeDrawer(this);
      });
    }
  }
  customElements.define('side-drawer', SideDrawer);

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.dataset.drawerOpen));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.side-drawer.is-open, .cart-drawer.is-open').forEach(closeDrawer);
  });

  /* ------------------------------------------------------------------
     Cart
     ------------------------------------------------------------------ */
  const cartDrawerEl = () => $('cart-drawer');
  const isCartPage = () => document.body.classList.contains('template-cart');
  const useDrawer = () => {
    const header = $('site-header');
    return header && header.dataset.cartType === 'drawer' && !isCartPage();
  };

  function renderCartSections(sections) {
    if (!sections || !sections['cart-drawer']) return;
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('cart-drawer');
    const current = cartDrawerEl();
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function refreshCount() {
    const res = await fetch(`${routes.cart}.js`);
    const cart = await res.json();
    updateCount(cart.item_count);
    return cart;
  }

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target === this || e.target.closest('[data-cart-close]')) closeDrawer(this);
      });
    }
  }
  customElements.define('cart-drawer', CartDrawer);

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && useDrawer()) {
      e.preventDefault();
      $('site-header')?.closeAll();
      openDrawer(cartDrawerEl());
    }
  });

  // Quantity +/- and remove in drawer and on the cart page.
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    const drawer = cartDrawerEl();
    drawer?.classList.add('is-loading');
    try {
      const res = await fetch(`${routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(btn.dataset.line), quantity: Number(btn.dataset.qtyChange), sections: ['cart-drawer'] }),
      });
      const cart = await res.json();
      if (isCartPage()) {
        window.location.reload();
        return;
      }
      renderCartSections(cart.sections);
      updateCount(cart.item_count);
    } finally {
      drawer?.classList.remove('is-loading');
    }
  });

  // Add to cart
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form.product-form')) return;
    if (!useDrawer()) return; // fall back to normal POST → /cart
    e.preventDefault();
    const button = $('[data-add-to-cart]', form);
    const text = $('[data-add-to-cart-text]', form);
    const errorEl = $('[data-form-error]', form);
    const original = text ? text.textContent : '';
    button.disabled = true;
    if (text) text.textContent = strings.adding || 'Adding…';
    errorEl && (errorEl.hidden = true);
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      const res = await fetch(`${routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await res.json();
      if (!res.ok || data.status) {
        if (errorEl) {
          errorEl.textContent = data.description || data.message || 'Something went wrong.';
          errorEl.hidden = false;
        }
        return;
      }
      renderCartSections(data.sections);
      await refreshCount();
      openDrawer(cartDrawerEl());
    } catch (err) {
      form.submit();
    } finally {
      button.disabled = false;
      if (text) text.textContent = original;
    }
  });

  /* ------------------------------------------------------------------
     Product page: variant picker + gallery
     ------------------------------------------------------------------ */
  class ProductPage extends HTMLElement {
    connectedCallback() {
      const json = $('[data-product-json]', this);
      this.data = json ? JSON.parse(json.textContent) : { variants: [] };
      this.form = $('form.product-form', this);
      this.sectionId = this.dataset.sectionId;

      $$('[data-option-input]', this).forEach((input) => input.addEventListener('change', () => this.onOptionChange()));
      this.markAvailability();

      $$('[data-qty-step]', this).forEach((b) =>
        b.addEventListener('click', () => {
          const input = b.parentElement.querySelector('input');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qtyStep));
        })
      );

      const track = $('[data-gallery-track]', this);
      const index = $('[data-gallery-index]', this);
      if (track && index) {
        track.addEventListener(
          'scroll',
          () => {
            index.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1;
          },
          { passive: true }
        );
      }
    }

    selectedOptions() {
      return $$('.product-option', this).map((fs) => {
        const checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    markAvailability() {
      const selected = this.selectedOptions();
      $$('.product-option', this).forEach((fs, i) => {
        $$('[data-option-input]', fs).forEach((input) => {
          const candidate = selected.slice();
          candidate[i] = input.value;
          const available = this.data.variants.some(
            (v) => v.available && v.options.every((opt, j) => j === i || candidate[j] === null || opt === candidate[j]) && v.options[i] === input.value
          );
          const label = input.nextElementSibling;
          label && label.classList.toggle('is-unavailable', !available);
        });
        const sel = $('[data-option-selected]', fs);
        if (sel) sel.textContent = selected[i] || '';
      });
    }

    async onOptionChange() {
      const selected = this.selectedOptions();
      this.markAvailability();
      const variant = this.data.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
      const button = $('[data-add-to-cart]', this);
      const text = $('[data-add-to-cart-text]', this);

      if (!variant) {
        button.disabled = true;
        text.textContent = strings.unavailable || 'Unavailable';
        return;
      }

      $$('input[name="id"]', this).forEach((i) => (i.value = variant.id));
      const installments = document.querySelector('#ProductInstallments input[name="id"]');
      if (installments) {
        installments.value = variant.id;
        installments.dispatchEvent(new Event('change', { bubbles: true }));
      }
      button.disabled = !variant.available;
      text.textContent = variant.available ? strings.addToCart || 'Add to bag' : strings.soldOut || 'Sold out';
      window.history.replaceState({}, '', `${this.dataset.productUrl}?variant=${variant.id}`);

      if (variant.featured_media) this.scrollToMedia(variant.featured_media.id);

      // Pull the server-rendered price so money formatting matches the shop.
      try {
        const res = await fetch(`${this.dataset.productUrl}?variant=${variant.id}&section_id=${this.sectionId}`);
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        const price = html.querySelector('[data-product-price]');
        const current = $('[data-product-price]', this);
        if (price && current) current.innerHTML = price.innerHTML;
      } catch (e) {
        /* keep previous price */
      }
    }

    scrollToMedia(mediaId) {
      const item = $(`[data-media-id="${mediaId}"]`, this);
      if (!item) return;
      const track = $('[data-gallery-track]', this);
      if (isDesktop()) {
        const top = item.getBoundingClientRect().top + window.scrollY - 60;
        window.scrollTo({ top, behavior: 'smooth' });
      } else if (track) {
        track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      }
    }
  }
  customElements.define('product-page', ProductPage);

  /* ------------------------------------------------------------------
     Horizontal product rail
     ------------------------------------------------------------------ */
  class ScrollRail extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-rail-track]', this);
      this.prev = $('[data-rail-prev]', this);
      this.next = $('[data-rail-next]', this);
      if (!this.track) return;
      const step = () => this.track.clientWidth * 0.75;
      this.prev?.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      this.next?.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.update();
    }
    update() {
      if (!this.prev || !this.next) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max;
    }
  }
  customElements.define('scroll-rail', ScrollRail);

  /* ------------------------------------------------------------------
     Product recommendations
     ------------------------------------------------------------------ */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const load = async () => {
        try {
          const res = await fetch(this.dataset.url);
          const html = new DOMParser().parseFromString(await res.text(), 'text/html');
          const fresh = html.querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
        } catch (e) {
          /* ignore */
        }
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) {
              io.disconnect();
              load();
            }
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        io.observe(this);
      } else {
        load();
      }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* ------------------------------------------------------------------
     Collection toolbar: sort + grid view
     ------------------------------------------------------------------ */
  $$('[data-sort-select]').forEach((select) =>
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    })
  );

  const grid = $('[data-product-grid]');
  const viewButtons = $$('[data-grid-view]');
  if (grid && viewButtons.length) {
    const setView = (v) => {
      grid.dataset.grid = v;
      viewButtons.forEach((b) => b.classList.toggle('is-active', b.dataset.gridView === v));
      try {
        localStorage.setItem('ace-grid-view', v);
      } catch (e) {
        /* storage unavailable */
      }
    };
    let saved = null;
    try {
      saved = localStorage.getItem('ace-grid-view');
    } catch (e) {
      /* storage unavailable */
    }
    setView(saved || '4');
    viewButtons.forEach((b) => b.addEventListener('click', () => setView(b.dataset.gridView)));
  }

  /* ------------------------------------------------------------------
     Footer columns: always open on desktop, accordions on mobile
     ------------------------------------------------------------------ */
  const syncFooter = () => $$('[data-footer-col]').forEach((d) => (isDesktop() ? d.setAttribute('open', '') : null));
  syncFooter();
  window.addEventListener('resize', syncFooter);

  /* ------------------------------------------------------------------
     Customer login: toggle password recovery
     ------------------------------------------------------------------ */
  const recover = $('#RecoverPassword');
  const login = $('#CustomerLogin');
  if (recover && login) {
    const sync = () => {
      const show = window.location.hash === '#recover';
      recover.hidden = !show;
      login.hidden = show;
    };
    window.addEventListener('hashchange', sync);
    sync();
  }

  onScroll();
})();
